// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"9c9305a0","236":"7a117021","422":"e7b6e6c2","514":"eabe92ab","529":"a29c91c7","708":"b427ca8f","810":"d6c7055e","837":"8dbeebc0","840":"ad848a8e","914":"b1b30c74","977":"21de866a"}[chunkId] + ".chunk.js";
};